import React, {
  useState,
  useEffect,
  useContext,
} from "react";

import { pdf } from "@react-pdf/renderer";
import GoodReceiptPDF from "./GoodReceiptPDF";

import Swal from "sweetalert2";
import api from "../../../api/api";
import { AuthContext } from "../../../AuthContext";

import {
  FaTimes,
  FaBox,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaTag,
} from "react-icons/fa";

import usFlag from "./flags/us.png";
import liberiaFlag from "./flags/liberia.png";

import "./ItemPopUp.css";

const ItemPopUp = ({
  open,
  shipment,
  onClose,
  onRefresh,
}) => {
  const { user } = useContext(AuthContext);

  const userType = user?.user_type;

  const canPayUS = userType === "owner";

  const canPayLiberia =
    userType === "admin" ||
    userType === "sales_agent";

  const [loading, setLoading] = useState(false);

  const [currentShipment, setCurrentShipment] =
    useState(null);

  const [paymentState, setPaymentState] =
    useState({
      us: false,
      liberia: false,
    });

  const [selectedPayment, setSelectedPayment] =
    useState("");

  const [amountPaid, setAmountPaid] =
    useState("");

  // ================= LOAD SHIPMENT =================
  useEffect(() => {
    if (!shipment) return;

    setCurrentShipment(shipment);

    setPaymentState({
      us: shipment.paid_to_us_boss || false,
      liberia: shipment.paid_in_liberia || false,
    });

    setSelectedPayment("");
    setAmountPaid("");
  }, [shipment]);

  if (!open || !currentShipment) return null;

  const balance = Number(
    currentShipment.balance || 0
  );

  // ================= STATUS =================
  let statusText = "Not Paid For!";
  let statusClass = "status-danger";

  if (
    paymentState.us &&
    paymentState.liberia
  ) {
    statusText = `Fully Paid Bal: $${balance.toLocaleString()}`;
    statusClass = "status-blue";
  } else if (paymentState.us) {
    statusText = `Paid in US Bal: $${balance.toLocaleString()}`;
    statusClass = "status-blue";
  } else if (paymentState.liberia) {
    statusText = `Paid in Liberia Bal: $${balance.toLocaleString()}`;
    statusClass = "status-orange";
  }

  // ================= PAYMENT SELECT =================
  const handlePayment = (type) => {
    setSelectedPayment(type);
    setAmountPaid("");
  };


  // ================= DOWNLOAD RECEIPT =================
const downloadReceipt = async (
  shipment,
  paymentAmount,
  paymentLocation
) => {
  try {
    const blob = await pdf(
      <GoodReceiptPDF
        shipment={shipment}
        paymentAmount={paymentAmount}
        paymentLocation={paymentLocation}
      />
    ).toBlob();

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download = `Receipt-${
      shipment.tracking_code || shipment.id
    }.pdf`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  } catch (error) {
    console.error(
      "Receipt generation failed:",
      error
    );

    Swal.fire(
      "Receipt Error",
      "Could not generate receipt PDF.",
      "error"
    );
  }
};

  // ================= SUBMIT PAYMENT =================
  const submitPayment = async () => {
    if (
      selectedPayment === "us" &&
      !canPayUS
    ) {
      Swal.fire(
        "Access Denied",
        "Only the owner can process USA payments.",
        "error"
      );
      return;
    }

    if (
      selectedPayment === "liberia" &&
      !canPayLiberia
    ) {
      Swal.fire(
        "Access Denied",
        "Only admin and sales agents can process Liberia payments.",
        "error"
      );
      return;
    }

    if (!selectedPayment) {
      Swal.fire(
        "Error",
        "Select payment location",
        "error"
      );
      return;
    }

    if (!amountPaid) {
      Swal.fire(
        "Error",
        "Enter amount paid",
        "error"
      );
      return;
    }

    setLoading(true);

    try {
      const endpoint =
        selectedPayment === "us"
          ? `/manage-shipments/${currentShipment.id}/pay_us_boss/`
          : `/manage-shipments/${currentShipment.id}/pay_liberia/`;

      // const res = await api.post(endpoint, {
      //   amount_paid: amountPaid,
      // });

      // const updated = res.data.shipment;

      // Swal.fire(
      //   "Success",
      //   res.data.message,
      //   "success"
      // );

      const paymentValue = Number(amountPaid);

const res = await api.post(endpoint, {
  amount_paid: paymentValue,
});

const updated = res.data.shipment;

// ================= AUTO DOWNLOAD RECEIPT =================
await downloadReceipt(
  updated,
  paymentValue,
  selectedPayment
);

Swal.fire(
  "Success",
  res.data.message,
  "success"
);

      setCurrentShipment(updated);

      setPaymentState({
        us: updated.paid_to_us_boss,
        liberia: updated.paid_in_liberia,
      });

      setSelectedPayment("");
      setAmountPaid("");

      if (onRefresh) {
        onRefresh();
      }
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.detail ||
        "Payment failed";

      Swal.fire("Error", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="popupOverlay">
      <div className="popupCard">

        {/* CLOSE */}
        <button
          className="closeBtn"
          onClick={onClose}
        >
          <FaTimes />
        </button>

        {/* LEFT */}
        <div className="popupLeft">

          {currentShipment.goods_image ? (
            <img
              src={currentShipment.goods_image}
              alt="Goods"
            />
          ) : (
            <div className="noImage">
              No Image
            </div>
          )}

          <div className="popupCenterBlock">

            <div
              className={`statusBadge ${statusClass}`}
            >
              {statusText}
            </div>

            {(canPayUS || canPayLiberia) && (
              <div className="paymentBox">

                <strong>
                  Payment Location
                </strong>

                <div className="paymentOptions">

                  {/* OWNER ONLY */}
                  {canPayUS && (
                    <label
                      className={`paymentOption ${
                        selectedPayment === "us"
                          ? "activePay"
                          : ""
                      }`}
                      onClick={() =>
                        handlePayment("us")
                      }
                    >
                      <input
                        type="radio"
                        checked={
                          selectedPayment === "us"
                        }
                        readOnly
                      />

                      <img
                        src={usFlag}
                        className="flagIcon"
                        alt="USA"
                      />

                      <span>
                        United States
                      </span>
                    </label>
                  )}

                  {/* ADMIN + SALES ONLY */}
                  {canPayLiberia && (
                    <label
                      className={`paymentOption ${
                        selectedPayment ===
                        "liberia"
                          ? "activePay"
                          : ""
                      }`}
                      onClick={() =>
                        handlePayment("liberia")
                      }
                    >
                      <input
                        type="radio"
                        checked={
                          selectedPayment ===
                          "liberia"
                        }
                        readOnly
                      />

                      <img
                        src={liberiaFlag}
                        className="flagIcon"
                        alt="Liberia"
                      />

                      <span>Liberia</span>
                    </label>
                  )}

                </div>

                {/* AMOUNT INPUT */}
                {selectedPayment && (
                  <div
                    style={{
                      marginTop: 12,
                      width: "100%",
                    }}
                  >
                    <input
                      type="number"
                      value={amountPaid}
                      onChange={(e) =>
                        setAmountPaid(
                          e.target.value
                        )
                      }
                      placeholder="Enter amount paid"
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "8px",
                        border:
                          "1px solid #ccc",
                      }}
                    />

                    <button
                      onClick={submitPayment}
                      disabled={loading}
                      style={{
                        marginTop: 10,
                        width: "100%",
                        padding: "10px",
                        background: "red",
                        color: "#fff",
                        border: "none",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                    >
                      {loading
                        ? "Processing..."
                        : "Submit Payment"}
                    </button>
                  </div>
                )}

              </div>
            )}

          </div>
        </div>

        {/* RIGHT */}
        <div className="popupRight">

          <h2 className="title">
            {currentShipment.customer_name}
          </h2>

          <p className="subtitle">
            Tracking:{" "}
            <b>
              {currentShipment.tracking_code ||
                "N/A"}
            </b>
          </p>

          <div className="infoSection">

            <div className="infoRow">
              <FaBox />

              <div>
                <span>Items</span>

                <div className="itemsBox">
                  {currentShipment.items_name}
                </div>
              </div>
            </div>

            <div className="infoRow">
              <FaEnvelope />

              <div>
                <span>Email</span>
                <p>
                  {currentShipment.email}
                </p>
              </div>
            </div>

            <div className="infoRow">
              <FaMapMarkerAlt />

              <div>
                <span>Receiver</span>
                <p>
                  {
                    currentShipment.receiver_name
                  }
                </p>
              </div>
            </div>

            <div className="infoRow">
              <FaPhone />

              <div>
                <span>Contact</span>
                <p>
                  {
                    currentShipment.receiver_contact
                  }
                </p>
              </div>
            </div>

            <div className="infoRow">
              <FaTag />

              <div>
                <span>Charge</span>

                <p className="price">
                  $
                  {
                    currentShipment.amount_charge
                  }
                </p>
              </div>
            </div>

            <div className="infoRow">
              <FaTag />

              <div>
                <span>Discount</span>

                <p className="discount">
                  -
                  {currentShipment.discount ||
                    0}
                  %
                </p>
              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
  );
};

export default ItemPopUp;